import ReactBundle from '~app/core/ReactBundle';
import AppBundleContext from '~app/core/AppBundleContext';

export default new ReactBundle({
  contexts: [AppBundleContext],
  language: 'en',
  resources: {
    strings: {
      languages: {
        en: () => require('./strings.json'),
      },
    },
    'ModelBuilderLogo.svg': {
      require: require('../images/logos/ModelBuilderLogo.svg'),
    },

    'add-icon.svg': {
      require: require('../images/icons/add-icon.svg'),
    },

    'close.svg': {
      require: require('../images/icons/close.svg'),
    },
  },
});
